import { Navigate } from "react-router";
import { ErrorScreen, LoadingScreen } from "../../screens/index.ts";
import { useLogin } from "./use-login.ts";

export const Login = ({
  externalId,
  provider,
  redirectTo,
}: {
  externalId: string;
  provider: string;
  redirectTo: string;
}) => {
  const { error, status } = useLogin({ externalId, provider, redirectTo });

  if (status === "idle" || status === "pending") {
    return <LoadingScreen />;
  }

  if (status === "error") {
    return <ErrorScreen error={error} />;
  }

  return <Navigate to={redirectTo} replace />;
};
